import React from 'react'
import { UncontrolledCollapse } from 'reactstrap'
import styles from './CollapsibleListGroup.module.scss'

export const CollapsibleListGroup = (props) => {

  return (
    <div className={styles.List__group__wrapper}>
      <div className={styles.List__group__header} id={props.id}>
        <span color="primary">
          {props.title}
        </span> 
        {/* <span className="float-right"><FontAwesomeIcon icon="chevron-up" /></span> */}
      </div>
      <UncontrolledCollapse toggler={'#' + props.id}>
        <div className={styles.List__group__body}>
          {props.description}
        </div>
      </UncontrolledCollapse>
    </div>
  );
}